



















import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import firebase, { firestore } from 'firebase';
import { DummyPlainObject } from "../../Classes/Entities";

@Component
export default class Account extends Vue {

   //TODO auth情報から取得するように変更
  public get name():string {
    const names:DummyPlainObject = {
      '3E9f2uVgwOa3g6FdmGsHgh7bGO02': '鈴木 涼介',
      '9EQnLueKkwRIk9weB6CZrslSOKO2': '田中 康夫',
      'MBUNtGUKY7fbPQQfxWq1Z92fvd73': '佐藤 史顕',
      'AxK2Bnt3S2WvkPUhTLFBmnav2bV2': '高橋 綾子',
      'jQJU7s4yvLNusL5Set9v0JSjDsi2': '山崎 恵美',
      'svc26irAkTO6SJvvEu7x1tj1OoH2': '長谷川 慎太郎',
      'z19i6aucp1awbNNYLDkbJU50d6S2': '渡辺 雄太',
    }

    const uid: string = firebase.auth().currentUser!.uid;
    const name:string = names[uid];
    return name;
  }
}
